import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <FAQSection />
        <IndexSection />
        <MediaSection />
        <AboutSection />
        <FeaturesSection />
        <AppSection />
        <CardsSection />
        <CommentsSection />
        <ContactSection />
        <TopicsSection />
        <RankingSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}